import { Alert, Space, Spin } from "antd";

import "./loader.css";
const Loader = () => <div class="loader"></div>;
export default Loader;
